<template>
    <section class="app-main">  
        <div class="top-bar">
            <el-input placeholder="搜索" v-model="search" @change="getData()"  style="width:300px;">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <el-card>
            <el-table ref="table" :data="tableData"  height="500" >
                <el-table-column label="日期"  min-width="120" align="center">
                    <template slot-scope="scope">
                        <i class="el-icon-time"></i>
                        <span style="margin-left: 10px">{{ scope.row.created_at }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="wallet_type_title" label="提现类型"  align="center" min-width="160"></el-table-column>
                <el-table-column prop="nickname" label="申请人" align="center">
                    <template slot-scope="scope">{{scope.row.first_name+'-'+scope.row.last_name}}</template>
                </el-table-column>
                <el-table-column prop="user.nickname" label="昵称" align="center"></el-table-column>
                <el-table-column prop="user.phone" label="联系方式" align="center">
                    <template slot-scope="scope">{{scope.row.user.phone == '' ? scope.row.user.email : scope.row.user.phone}}</template>
                </el-table-column>
                <el-table-column prop="transit_number" label="银行卡号" min-width="160" align="center" >
                     <template slot-scope="scope">{{scope.row.transit_number + ' '+ scope.row.institiution_number + ' '+ scope.row.account_number}}</template>
                </el-table-column>
                <el-table-column prop="amount" label="提现金额"  align="center"> </el-table-column>
                <el-table-column prop="service_charge" label="手续费"  align="center"></el-table-column>
                <el-table-column prop="" label="操作"  align="center" width="160">
                    <template slot-scope="scope">
                        <div v-if="scope.row.audit_status == 1">
                            <el-button type="success" size="mini" v-if="scope.row.transfer_status == 0" @click="payment(scope.row)">打款</el-button>
                            <el-link type="success" v-if="scope.row.transfer_status == 1">已打款</el-link>
                        </div>
                        <div v-else-if="scope.row.audit_status == 0">
                            <el-button type="success" size="mini" @click="changeStatus(scope.row, 1)">通过</el-button>
                            <el-button type="danger" size="mini" @click="refuse(scope.row, -1)">拒绝</el-button>
                        </div>
                        <div v-else>
                            <span>已拒绝</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper" :current-page.sync="page" style="padding:10px" :total="total"  @current-change="loadPage"></el-pagination>
        </el-card>
        <el-dialog width="600px"  title="驳回原因" :visible.sync="innerVisible" align="center" append-to-body>
            <div class="refuse-reasons">
                <el-input v-model="reason" placeholder="请输入驳回原因"></el-input>
            </div>
            <el-row style="margin-top:20px;text-align:right"><el-button type="primary" style="width:120px;" @click="refuse( 0 ,-1)">确定</el-button></el-row>
        </el-dialog>
    </section>
</template>
<script>
import { withdrawal_list, withdrawal_put } from '@/api/merchant.js'
export default {
    data() {
        return {
            search: '',
            page:1,
            total:0,
            tableData:[],
            innerVisible: false,
            row: '',
            reason: ''
        }
    },
    methods: {
        getData(){
            let params = { page: this.page }
            if(this.search != '') {
                params.keywords = this.search
            }
            withdrawal_list(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                }
            })
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
        // 修改审核状态
        changeStatus(row, status){
            let params = {
                audit_status: status,
            }
            if(status == -1) {
                params.reason = this.reason
            }
            withdrawal_put(row.id ,params).then(res => {
                if(res) {
                    this.$message.success(res.msg)
                    this.innerVisible = false
                    this.getData()
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 拒绝
        refuse(row, i) {
            if(row != 0) {
                this.innerVisible = true
                this.row = row
            } else {
                this.changeStatus(this.row, i)
            }
        },
        // 打款
        payment(row) {
            this.$confirm(`此操作将确认已打款给申请人：${row.first_name+'-'+row.last_name}, 是否继续?`, '提示', {
                type: 'warning'
            }).then(() => {
                let params = {
                    transfer_status: 1
                }
                withdrawal_put(row.id ,params).then(res => {
                    if(res) {
                        this.$message.success('操作成功')
                        this.getData()
                    }
                })
            }).catch(()=>{})
            
        }
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>



